/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'

// Create Virtual Routes

const MeasurementLazyImport = createFileRoute('/measurement')()
const IndexLazyImport = createFileRoute('/')()

// Create/Update Routes

const MeasurementLazyRoute = MeasurementLazyImport.update({
  id: '/measurement',
  path: '/measurement',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/measurement.lazy').then((d) => d.Route))

const IndexLazyRoute = IndexLazyImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/measurement': {
      id: '/measurement'
      path: '/measurement'
      fullPath: '/measurement'
      preLoaderRoute: typeof MeasurementLazyImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/measurement': typeof MeasurementLazyRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/measurement': typeof MeasurementLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexLazyRoute
  '/measurement': typeof MeasurementLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/measurement'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/measurement'
  id: '__root__' | '/' | '/measurement'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  MeasurementLazyRoute: typeof MeasurementLazyRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  MeasurementLazyRoute: MeasurementLazyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/measurement"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/measurement": {
      "filePath": "measurement.lazy.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
